import { z } from 'zod';
import { amountUnitValues } from '@/shared/lib/amount/convertAmount';

/**
 * 査定比較ページ（年度明細 base / 差分 ai）共通の URL search schema。
 *
 * `amount_unit` / `sort` / `order` を両ルートで共有する単一定義。
 * 差分（diff）ルートは `accumulationId` を追加で持つため `.extend(...)` で拡張する。
 *
 * sort/order の値の妥当性は `parseSortConditions` 側で型ガードにより寛容にフィルタするため、
 * ここでは string 配列として受け入れる（旧 URL や typo 由来の不正値でルート読み込みが
 * 失敗するのを避ける）。
 *
 * 注: 事業一覧ルート（projects）の `sort_by`/`sort_order` と意図的にキー名を分けている。
 * TanStack Router の navigate `prev` は全ルートの search の union 型になり、
 * 同名キーで型が異なると spread 時に型エラーを引き起こすため。
 */
export const assessmentComparisonSearchSchema = z.object({
  amount_unit: z.enum(amountUnitValues).optional(),
  sort: z.array(z.string()).optional(),
  order: z.array(z.string()).optional(),
});
